import React, { useCallback } from 'react';

import { useMembershipAdjustPoints } from '@occc-app/dataAccessLayer/membership/mutations';
import { useChainConfiguration } from '@occc-app/Chain/hooks';
import { MembershipAdjustPointsInput } from '@occc/graphql';

import PointChangeModal from './UpdatePointsModal';
import { UpdatePointsModalFormFields } from './types';

export interface IUpdatePointsModalContainerProps {
  customerUuid: string;
  show: boolean;
  onHide: () => void;
}

const UpdatePointsModalContainer: React.FC<IUpdatePointsModalContainerProps> = ({
  customerUuid,
  show,
  onHide,
}) => {
  const [adjustPoints] = useMembershipAdjustPoints({
    refetchQueries: ['membershipActivities'],
  });
  const { manualPointChangeCap } = useChainConfiguration();

  const onSubmit = useCallback(
    (inputs: UpdatePointsModalFormFields) => {
      const update: MembershipAdjustPointsInput = {
        notes: inputs.notes,
        points: inputs.points,
        mathematicalFunction: inputs.mathematicalFunction,
        customerUuid: customerUuid,
        pointAdjustmentReasonId: inputs.adjustmentReasonId,
      };

      adjustPoints({
        variables: {
          input: update,
        },
      }).finally();
      onHide();
    },
    [adjustPoints, onHide, customerUuid],
  );

  return (
    <PointChangeModal
      show={show}
      onHide={onHide}
      onSubmit={onSubmit}
      customerUuid={customerUuid}
      maxAdjustmentValue={manualPointChangeCap}
    />
  );
};

export default UpdatePointsModalContainer;
